export default __webpack_public_path__ + "static/media/Aura-Egg__50.16596534.png";